import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from './ui/badge';
import { cn } from '../lib/utils';

const ProductCard = ({ product, className }) => {
  // Handle both API format (is_new, is_sale) and mock format (isNew, isSale)
  const isNew = product.is_new || product.isNew;
  const isSale = product.is_sale || product.isSale;
  const originalPrice = product.original_price || product.originalPrice;

  return (
    <Link 
      to={`/product/${product.id}`}
      className={cn(
        "group block",
        className
      )}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-stone-100 rounded-sm">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3 flex flex-col gap-2">
          {isNew && (
            <Badge className="bg-accent-ui text-white border-0 text-xs font-medium">
              New
            </Badge>
          )}
          {isSale && (
            <Badge className="bg-tangerine text-white border-0 text-xs font-medium">
              Sale
            </Badge>
          )}
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" />
      </div>
      <div className="mt-4 space-y-1">
        <h3 className="text-text-primary font-medium text-sm group-hover:text-accent-ui transition-colors">
          {product.name}
        </h3>
        <p className="text-text-subtle text-xs line-clamp-1">
          {product.description}
        </p>
        <div className="flex items-center gap-2 pt-1">
          <span className="text-text-primary font-semibold">
            ${product.price.toFixed(2)}
          </span>
          {originalPrice && (
            <span className="text-text-subtle text-sm line-through">
              ${originalPrice.toFixed(2)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
